import TextField from 'material-ui/TextField'
import { ResponsiveDialog } from 'common-frontend'
import { NotFoundCheckDetailActions, GlobalErrorActions } from 'actions'
import { NotFoundDetailsHeader, SupportForm, Button, Notice, UpgradeScopesLink, Loading, HelpLink, HelpEmail } from 'components'
import FontIcon from 'material-ui/FontIcon'
import EditIcon from 'material-ui/svg-icons/image/edit'
import BuildIcon from 'material-ui/svg-icons/action/build'
import VisibilityIcon from 'material-ui/svg-icons/action/visibility'
import VisibilityOffIcon from 'material-ui/svg-icons/action/visibility-off'
import { SeoHelpers } from 'helpers'
import Immutable from 'immutable'
import { SUPPORT_URL } from 'consts'

import './notFoundDetails.scss'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

export default class NotFoundDetails extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object.isRequired
  }

  static propTypes = {
    result:     React.PropTypes.object.isRequired,
    check:      React.PropTypes.object.isRequired,
    checkType:  React.PropTypes.object.isRequired,
    isFetching: React.PropTypes.bool.isRequired
  }

  state = {
    linkForFix: {},
    domainForFix: '',
    showFixDialog: false,
    redirectUri: '',
    redirectError: '',
    submittingRedirect: false,
    activeTab: 'broken',
    isFetchingRedirects: false,
    isFetchingFreeBrokenLinkStatus: false,
    isFetchingIgnoredLinks: false,
    isFailedInstallation: false,
    isFetchingMainBrokenLinks: false,
    needsFreeInstall: false,
    needsFreeUpgrade: false,
    hasFreeInclude: false,
    currentPageLinks: [],
    paginationInfo: {},
  }

  componentWillMount() {
    const { activeCharge } = this.context.currentUser

    if (!activeCharge) {
      this.fetchFreeBrokenLinkStatus()
    } else {
      this.switchToMainBrokenLinksPage(1)
    }
  }

  fetchFreeBrokenLinkStatus() {
    this.setState({ isFetchingFreeBrokenLinkStatus: true })

    NotFoundCheckDetailActions.fetchFreeBrokenLinkStatus()
      .then(result => {
        const { needsFreeUpgrade, needsFreeInstall, hasFreeInclude } = result;
        this.setState({ isFetchingFreeBrokenLinkStatus: false, needsFreeInstall, needsFreeUpgrade, hasFreeInclude });
      })
      .catch(() => {
        this.setState({ isFetchingFreeBrokenLinkStatus: false })
      })
  }

  fetchRedirects() {
    this.setState({ isFetchingRedirects: true })

    NotFoundCheckDetailActions.fetchRedirects()
      .then(redirects => {
        this.setState({ isFetchingRedirects: false, redirects })
      })
      .catch(() => {
        this.setState({ isFetchingRedirects: false })
      })
  }

  switchToRedirectPage() {
    this.setState({ isFetchingRedirects: true })
    this.setState({ activeTab: 'redirects' })

    NotFoundCheckDetailActions.fetchRedirects()
      .then(redirects => {
        this.setState({ isFetchingRedirects: false, redirects })
      })
      .catch(() => {
        this.setState({ isFetchingRedirects: false })
        alert("ERROR: ERR_FETCH_REDIR_PAGE. Please contact our support.")
      })
  }

  switchToIgnoredLinksPage() {
    this.setState({ activeTab: 'ignores' })
    this.setState({ isFetchingIgnoredLinks: true })

    NotFoundCheckDetailActions.fetchFullCheck()
      .then(redirects => {
        this.setState({ isFetchingIgnoredLinks: false, redirects })
      })
      .catch(() => {
        this.setState({ isFetchingIgnoredLinks: false })
        alert("ERROR: ERR_FETCH_IGNR_PAGE. Please contact our support.")
      })
  }

  switchToMainBrokenLinksPage(pageNum) {
    this.setState({ activeTab: 'broken' })

    this.setState({ isFetchingMainBrokenLinks: true })

    NotFoundCheckDetailActions.fetchPaginatedMainBrokenLinks(pageNum)
      .then(result => {
        this.setState({
          isFetchingMainBrokenLinks: false,
          currentPageLinks: result.links,
          paginationInfo: result.paginationInfo
        });
      })
      .catch(() => {
        this.setState({ isFetchingMainBrokenLinks: false })
        alert("ERROR: ERR_FETCH_MNPG. Please contact our support.")
      })
  }

  installFreeSnippet() {
    this.setState({ isFetchingFreeBrokenLinkStatus: true })

    NotFoundCheckDetailActions.installFreeSnippet()
      .then(result => {
        const { success } = result
        this.setState({
          isFetchingFreeBrokenLinkStatus: false,
          isFailedInstallation: !success,
          needsFreeInstall: false,
          needsFreeUpgrade: false,
          hasFreeInclude: success,
        })
      })
      .catch(() => {
        this.setState({ isFetchingFreeBrokenLinkStatus: false, isFailedInstallation: true })
      })
  }

  // Legacy
  toggleIgnore(id) {
    const ignored = !this.props.result.toJS().checks.find(x => x.id === id).ignored
    NotFoundCheckDetailActions.update(id, { ignored })
  }

  // Legacy
  toggleIgnore2(id, currentIgnoreValue) {
    this.setState({ isFetchingMainBrokenLinks: true })
    const ignored = !this.props.result.toJS().checks.find(x => x.id === id).ignored
    NotFoundCheckDetailActions.update(id, { ignored }).then(() => {
      this.switchToMainBrokenLinksPage(this.state.paginationInfo.current)
    })
  }

  onFixClick(link) {
    const matches = link.url.match(/^https?\:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i)

    this.setState({
      editMode: false,
      linkForFix: link,
      domainForFix: matches[0].substr(0, matches[0].length-1),
      showFixDialog: true,
      redirectError: null,
      redirectUri: ''
    })
  }

  onEditRedirect(redirect) {
    const domainForFix = `https://${this.context.currentUser.shop}`
    
    this.setState({
      editMode: true,
      linkForFix: {
        id: redirect.id,
        url: domainForFix + redirect.path
      },
      redirectUri: redirect.target,
      showFixDialog: true,
      redirectError: null,
      domainForFix,
    })
  }

  setRedirectUri(val) {
    this.setState({
      redirectUri: val
    })
  }

  submitRedirect() {
    const { linkForFix, domainForFix, redirectUri, editMode } = this.state
    this.setState({ submittingRedirect: true, redirectError: null })

    let redirectOp
    if (editMode) {
      redirectOp = NotFoundCheckDetailActions.updateRedirect(linkForFix.id, redirectUri)
    } else {
      const path = linkForFix.url.substr(domainForFix.length)

      redirectOp = NotFoundCheckDetailActions.redirect(linkForFix.id, { path, target: redirectUri })
    }    

    redirectOp
      .then(result => {
        let updateBody = {
          submittingRedirect: false,
          showFixDialog: false
        }

        if (editMode) {
          updateBody.redirects = result
          this.setState(updateBody)
        } else {
          this.setState(updateBody, () => {
            this.fetchRedirects()
          })
        }

        if (this.state.activeTab == 'broken') {
          this.switchToMainBrokenLinksPage(this.state.paginationInfo.current)
        }
      })
      .catch(error => {
        const { reason } = error.response.data

        if (reason === 'invalid_target') {
          this.setState({ submittingRedirect: false, redirectError: error.response.data })
        } else {
          GlobalErrorActions.setGlobalError("There's been an error. Please refresh the page to try again.")
          this.setState({ submittingRedirect: false })
        }
      })
  }

  closeFixDialog() {
    if (this.state.submittingRedirect) return

    this.setState({
      showFixDialog: false
    })
  }

  getColor({ hits }) {
    const { warnHits, criticalHits } = this.props.check
    let color = '#000'

    if (hits >= warnHits && hits < criticalHits)
      color = '#FEC455'
    else if (hits >= criticalHits)
      color = '#ED6A6B'

    return color
  }

  hasSufficientAccessScope() {
    return this.context.currentUser.accessScopes.includes("write_content")
  }

  maybeRenderAccessScopeMissingWarning() {
    if (this.hasSufficientAccessScope()) return

    return (
      <Notice alert header="Permission Required to Publish URL Redirects">
        <p>
          Plug in SEO requires your permission to publish broken link redirects to your Shopify admin.
        </p>
        <p>
          <UpgradeScopesLink
            className="large-spacing2--top"
            buttonType="primary"
            scopes={["write_content"]}
            label="Approve and Update" />
        </p>
      </Notice>
    )
  }

  renderRedirectError() {
    const { redirectError } = this.state

    if (!redirectError) return null
    if (redirectError.reason === 'invalid_target') {
      return (
        <Notice
          error
          header="Invalid Redirect URL"
        >
          <p>
            The url you have choosen to redirect to is invalid. You can view more details <a href="https://support.pluginuseful.com/hc/en-us/articles/23534821393684-Day-3-Broken-links-and-structured-data" target="_blank">here</a>.
          </p>
          <p className="medium-spacing2--top">
            Please update the redirect url and try again.
          </p>
        </Notice>
      )
    }

    return null
  }

  renderFixDialog() {
    const { domainForFix, showFixDialog, linkForFix, redirectUri, submittingRedirect, editMode } = this.state

    return (
      <ResponsiveDialog
        title={editMode ? 'Edit This Redirect Link' : 'Fix This Broken Link'}
        modal
        open={showFixDialog}
        onRequestClose={::this.closeFixDialog}
        maxWidth="750px"
      >
        { this.maybeRenderAccessScopeMissingWarning() }
        { this.renderRedirectError() }
        <div className="large-spacing--top">
          <h3>Redirect from</h3>
          <div className="notFoundDetails__url">
            <div className="notFoundDetails__url__fixed full-width">{linkForFix.url}</div>
          </div>
          <h3 className="medium-spacing--top">Redirect to</h3>
          <div className="notFoundDetails__url">
            <div className="notFoundDetails__url__fixed">{domainForFix}</div>
            <div className="notFoundDetails__url__input">
              <TextField
                placeholder="Add new link"
                fullWidth
                value={redirectUri}
                onChange={({ target: { value } }) => this.setRedirectUri(value)}
              />
              <div className="hint">ex. /products/laughing-woman-at-computer</div>
            </div>
          </div>
          <div className="large-spacing2--top">
            <Button
              label={submittingRedirect ? 'Saving Redirect...' : 'Save Redirect'}
              buttonType="primary"
              disabled={!this.hasSufficientAccessScope() || !redirectUri || submittingRedirect}
              onTouchTap={::this.submitRedirect}
            />
            <Button
              label='Cancel'
              buttonType="secondary"
              onTouchTap={::this.closeFixDialog}
              disabled={submittingRedirect}
              className="secondary-btn"
            />
          </div>
        </div>
      </ResponsiveDialog>
    )
  }

  renderRedirects() {
    const { isFetchingRedirects, redirects } = this.state
    const { palette } = this.context.muiTheme

    if (isFetchingRedirects) {
      return (
        <div className='notFoundDetails__content__sheet'>
          <Loading />
        </div>
      )
    }

    return (
      <div className='notFoundDetails__content__sheet'>
        {(!redirects || redirects.length < 1) &&
          <div>
            <h2 className="notFoundDetails__header">Redirected Links</h2>
            <div className="notFoundDetails__empty-state">
              <h3 className="notFoundDetails__empty-state-header">No redirects created</h3>
              <p className="medium-spacing2--top">Maintain strong SEO by fixing broken links</p>
            </div>
            <hr />
            <h3>Learn More</h3>
            <ul className="icon-font-list">
              <HelpLink
                title="How do I set up my broken links and redirects?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534784244372-How-do-I-set-up-my-broken-links-and-redirects"
              />
              <HelpLink
                title="Where should I redirect broken links?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534823014804-Where-should-I-redirect-broken-links"
              />
            </ul>
          </div>
        }
        {redirects && redirects.length > 0 &&
          <Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn><h5>Original URL</h5></TableHeaderColumn>
                <TableHeaderColumn><h5>Redirect URL</h5></TableHeaderColumn>
                <TableHeaderColumn style={{ width: 88, textAlign: 'center' }}><h5>Edit</h5></TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {redirects.map(redirect =>
                <TableRow key={redirect.id}>
                  <TableRowColumn><p className="body2">{redirect.path}</p></TableRowColumn>
                  <TableRowColumn><p className="body2">{redirect.target}</p></TableRowColumn>
                  <TableRowColumn style={{ width: 88, textAlign: 'center' }}>
                    <EditIcon onTouchTap={() => this.onEditRedirect(redirect)} style={{ cursor: 'pointer', color: palette.textColor }} className="in-text-icon" />
                  </TableRowColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>
        }
      </div>
    )
  }

  renderIgnoredLinks() {
    const { isFetchingIgnoredLinks } = this.state
    if (isFetchingIgnoredLinks) {
      return (
        <div className='notFoundDetails__content__sheet'>
          <Loading />
        </div>
      )
    }

    const checks = this.props.result.toJS().checks || []
    let links = checks.filter(x => x.httpStatus === 404)
    links = links.filter(link => link.ignored)
    links.sort((a, b) => {
      if (a.hits == b.hits) return 0
      if (a.hits > b.hits) return -1
      return 1
    })

    const palette = this.context.muiTheme.palette

    return (
      <div className='notFoundDetails__content__sheet'>
        { !links || links.length < 1 &&
          <div>
            <h2 className="notFoundDetails__header">Ignored Links</h2>
            <div className="notFoundDetails__empty-state">
              <h3 className="notFoundDetails__empty-state-header">No ignored links</h3>
              <p className="medium-spacing2--top">Keep your work-flow efficient by ignoring low-value broken links</p>
            </div>
            <hr />
            <h3>Learn More</h3>
            <ul className="icon-font-list">
              <HelpLink
                title="How do I set up my broken links and redirects?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534784244372-How-do-I-set-up-my-broken-links-and-redirects"
              />
              <HelpLink
                title="How do broken link redirects help my SEO?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534839771540-How-do-broken-link-redirects-help-my-SEO"
              />
            </ul>
          </div>
        }
        { links && links.length > 0 &&
          <Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn style={{ width: 60, paddingLeft: 16 }}><h5>Hits</h5></TableHeaderColumn>
                <TableHeaderColumn style={{ width: 48 }}></TableHeaderColumn>
                <TableHeaderColumn><h5>URL</h5></TableHeaderColumn>
                <TableHeaderColumn style={{ width: 60 }}><h5>Fix</h5></TableHeaderColumn>
                <TableHeaderColumn style={{ width: 88 }}><h5>Ignore</h5></TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {
                links.map(link =>
                  <TableRow key={link.id}>
                    <TableRowColumn style={{ width: 60, color: palette.disabledTextColor, paddingLeft: 32 }}>
                        <p className="body2">{link.hits}</p>
                    </TableRowColumn>
                    <TableRowColumn style={{ width: 48 }}></TableRowColumn>
                    <TableRowColumn style={{ wordBreak: 'break-all', whiteSpace: 'initial', color: palette.disabledTextColor }}>
                      <p className="body2">{link.url.replace(/^.*\/\/[^\/]+/, '')}</p>
                    </TableRowColumn>
                    <TableRowColumn style={{ width: 60, textAlign: 'center' }}>
                      <BuildIcon onTouchTap={this.onFixClick.bind(this, link)} style={{ cursor: 'pointer', color: palette.disabledTextColor }} className="in-text-icon" />
                    </TableRowColumn>
                    <TableRowColumn style={{ width: 88, textAlign: 'center' }}>
                      <VisibilityOffIcon style={{ cursor: 'pointer', color: palette.disabledTextColor }} onTouchTap={this.toggleIgnore.bind(this, link.id)} className="in-text-icon" />
                    </TableRowColumn>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        }
      </div>
    )
  }

  renderPagination() {
    const { current, previous, next, pages } = this.state.paginationInfo

    return (
      <div>
        { 
          previous != null &&
          <Button
            label="< Previous Page"
            buttonType="primary"
            className="customer-feedback__form__btn--yes"
            onTouchTap={() => this.switchToMainBrokenLinksPage(current - 1)}
          />
        }
        <span>Page {current} of {pages} </span>
        { 
          next != null &&
          <Button
            label="Next Page >"
            buttonType="primary"
            className="customer-feedback__form__btn--yes"
            onTouchTap={() => this.switchToMainBrokenLinksPage(current + 1)}
          />
        }
      </div>
    )
  }

  renderBrokenLinks() {
    const { isFetchingMainBrokenLinks, currentPageLinks } = this.state
    const { activeCharge } = this.context.currentUser;

    const totalLinks = this.state.paginationInfo.count
    const perPageLinks = this.state.paginationInfo.perPage

    if (isFetchingMainBrokenLinks) {
      return (
        <div className='notFoundDetails__content__sheet'>
          <Loading />
        </div>
      )
    }

    const links = currentPageLinks;

    const palette = this.context.muiTheme.palette

    return (
      <div className='notFoundDetails__content__sheet'>
        { !links || links.length < 1 &&
          <div>
            <h2 className="notFoundDetails__header">Broken Links</h2>
            <div className="notFoundDetails__empty-state">
              <h3 className="notFoundDetails__empty-state-header">No broken links found</h3>
              <p className="medium-spacing2--top">If you&apos;ve fixed all of your broken links, nice work!</p>
              <p className="medium-spacing2--top">Or, if you&apos;ve just enabled this check and have any broken links, they&apos;ll start to appear here when found.</p>
              <ul className="icon-font-list large-spacing2--top">
                <HelpLink
                  title="How can I verify that my broken links check is working?"
                  url="https://support.pluginuseful.com/hc/en-us/articles/23534780823444-How-can-I-verify-that-my-broken-links-check-is-working"
                />
              </ul>
            </div>
            <hr />
            <h3>Learn More</h3>
            <ul className="icon-font-list">
              <HelpLink
                title="What are broken links and redirects?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534852600596-What-are-broken-links-and-redirects"
              />
              <HelpLink
                title="How do I set up my broken links and redirects?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534784244372-How-do-I-set-up-my-broken-links-and-redirects"
              />
            </ul>
          </div>
        }
        { links && links.length > 0 &&
          <span>You have { totalLinks } broken links.</span>
        }
        { links && links.length > 0 &&
          <Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn style={{ width: 60, paddingLeft: 16 }}><h5>Views</h5></TableHeaderColumn>
                <TableHeaderColumn style={{ width: 48 }}></TableHeaderColumn>
                <TableHeaderColumn><h5>URL</h5></TableHeaderColumn>
                {activeCharge && <TableHeaderColumn style={{ width: 60 }}><h5>Fix</h5></TableHeaderColumn>}
                {activeCharge && <TableHeaderColumn style={{ width: 88 }}><h5>Ignore</h5></TableHeaderColumn>}
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {
                links.map(link =>
                  <TableRow key={link.id}>
                    <TableRowColumn style={{ width: 60, color: palette.textColor, paddingLeft: 32 }}>
                        <p className="body2">{link.hits}</p>
                    </TableRowColumn>
                    <TableRowColumn style={{ width: 48 }}>
                      { link.severity !== 'Pass' &&
                        <span style={{ color: this.getColor(link) }}>
                          {SeoHelpers.severityIcon(link.severity)}
                        </span>
                      }
                    </TableRowColumn>
                    <TableRowColumn style={{ wordBreak: 'break-all', whiteSpace: 'initial', color: palette.textColor }}>
                      <p className="body2">{link.url.replace(/^.*\/\/[^\/]+/, '')}</p>
                    </TableRowColumn>
                    { activeCharge &&
                      <TableRowColumn style={{ width: 60, textAlign: 'center' }}>
                        <BuildIcon onTouchTap={this.onFixClick.bind(this, link)} style={{ cursor: 'pointer', color: palette.textColor }} className="in-text-icon" />
                      </TableRowColumn>
                    }
                    { activeCharge &&
                      <TableRowColumn style={{ width: 88, textAlign: 'center' }}>
                          <VisibilityIcon style={{ cursor: 'pointer', color: palette.textColor }} onTouchTap={this.toggleIgnore2.bind(this, link.id, link.ignored)} className="in-text-icon" />
                      </TableRowColumn>
                    }
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        }
        { links && links.length > 0 && !activeCharge &&
          <p>
            You have { totalLinks } broken links.
            { totalLinks > perPageLinks &&
              <span>
                Here are the top { perPageLinks }.
                The rest are visible by upgrading to Plug in SEO Plus.
              </span>
            }
          </p>
        }
        { links && links.length > 0 && !activeCharge &&
          <p>The links above are invalid. These can be fixed manually or by upgrading to Plug in SEO Plus.</p>
        }
        {
          activeCharge && this.renderPagination()
        }
      </div>
    )
  }

  renderFreeLinkStatus() {
    const { isFetchingFreeBrokenLinkStatus, needsFreeUpgrade, isFailedInstallation } = this.state

    let needsFreeInstall
    needsFreeInstall = false
    if (!needsFreeUpgrade) {
      needsFreeInstall = this.state.needsFreeInstall || (!this.state.hasFreeInclude)
    }

    let operationType

    if (needsFreeInstall) {
      operationType = "install"
    } else {
      operationType = "update"
    }

    if (isFetchingFreeBrokenLinkStatus) {
      return (
        <div className='notFoundDetails__content__sheet'>
          <h2 className="notFoundDetails__header">Processing...</h2>
        </div>
      )
    }

    if (isFailedInstallation) {
      return (
        <div className='notFoundDetails__content__sheet'>
          <div className={`customer-feedback__form`}>
            <h3>Installation Failed</h3>

            <p>The code snippet was not installed. Please contact help@pluginuseful.com for assistance.</p>
          </div>
        </div>
      )
    }

    if (!needsFreeInstall && !needsFreeUpgrade) {
      return (
      <div></div>
      )
    }

    return (
      <div className='notFoundDetails__content__sheet'>
        <div className={`customer-feedback__form`}>
          {
            needsFreeInstall && <h3>Installation Required</h3>
          }
          {
            needsFreeUpgrade && <h3>Update Required</h3>
          }

          <p>To check for broken links, a code snippet is required. Please click {operationType} to continue.</p>

          <Button
            label={operationType}
            buttonType="primary"
            className="customer-feedback__form__btn--yes"
            onTouchTap={() => this.installFreeSnippet()}
          />  
        </div>
      </div>
    )
  }

  render() {
    const { result } = this.props
    const { activeTab, needsFreeInstall, needsFreeUpgrade } = this.state
    const { activeCharge } = this.context.currentUser;

    const shouldShowDefaultContent = activeCharge || (!needsFreeInstall && !needsFreeUpgrade)

    return (
      <div>
        <NotFoundDetailsHeader check={this.props.check} isFetching={this.props.isFetching} result={result} checkType={this.props.checkType} />
        {this.renderFixDialog()}
        <div className="notFoundDetails__content">
          <div className="notFoundDetails__tabs">
            <h4
              className={`notFoundDetails__tabs__tab ${activeTab === 'broken' ? 'active' : ''}`}
              onClick={() => this.switchToMainBrokenLinksPage(1)}
            >Broken Links</h4>
            { activeCharge &&
            <h4
              className={`notFoundDetails__tabs__tab ${activeTab === 'redirects' ? 'active' : ''}`}
              onClick={() => this.switchToRedirectPage()}
            >Redirected Links</h4>
            }
            { activeCharge &&
            <h4
              className={`notFoundDetails__tabs__tab ${activeTab === 'ignores' ? 'active' : ''}`}
              onClick={() => this.switchToIgnoredLinksPage()}
            >Ignored Links</h4>
            }
          </div>
          <div className="notFoundDetails__tabContent">
            <div>
              { !activeCharge && this.renderFreeLinkStatus()}
              {shouldShowDefaultContent && activeTab === 'broken' && this.renderBrokenLinks()}
              {shouldShowDefaultContent && activeTab === 'redirects' && this.renderRedirects()}
              {shouldShowDefaultContent && activeTab === 'ignores' && this.renderIgnoredLinks()}
            </div>
            {
              activeCharge &&
              <div className="notFoundDetails__feedback-container">
                <SupportForm
                  href={SUPPORT_URL}
                  featureType="links"
                  featureKey="links"
                />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/NotFoundDetails.js